import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DeviceStatus } from '../../types';
import { EyeIcon, StatusWrapper, SunIcon, WakeUpIcon } from './styled';
export default function Status({ status, isInvalidCode }) {
    if (isInvalidCode) {
        return (_jsxs(StatusWrapper, { children: [_jsx(EyeIcon, {}), "Check if the code is ", _jsx("br", {}), "correct and try again"] }));
    }
    return (_jsxs(StatusWrapper, { children: [status === DeviceStatus.online && (_jsxs(_Fragment, { children: [_jsx(SunIcon, {}), "OMNIHOME is ready to go!"] })), status === DeviceStatus.offline && (_jsxs(_Fragment, { children: [_jsx(WakeUpIcon, {}), "OMNIHOME is waking up! ", _jsx("br", {}), "Give it 5 seconds"] }))] }));
}
